import { useEffect, useState } from 'react';

/**
 * IL TEMPO CHE RESTA, scritto come lo legge una persona: m:ss, e sopra l'ora
 * «1h 12m». E' la stessa forma di BloccoRiproposta, perche' il numero sotto la
 * schedina, nella lista e dentro il ticket deve essere LO STESSO numero.
 *
 * Il momento di scadenza (scadeIl) e' SALVATO sul ticket e non si ricalcola:
 * un conto alla rovescia che si allunga sotto gli occhi di chi decide non si
 * puo' vedere. Qui si fa solo la sottrazione.
 */
export function restante(scadeIl, adesso = Date.now()) {
  if (!scadeIl) return '';
  const fine = new Date(scadeIl).getTime();
  if (Number.isNaN(fine)) return '';
  const ms = fine - adesso;
  if (ms <= 0) return '0:00';
  const sec = Math.floor(ms / 1000);
  if (sec >= 3600) return `${Math.floor(sec / 3600)}h ${Math.floor((sec % 3600) / 60)}m`;
  return `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, '0')}`;
}

/**
 * Un battito al secondo, SOLO quando serve: con `attivo` falso non c'e'
 * nessun intervallo e nessun ridisegno. Una pagina con cinquanta giocate
 * tutte chiuse non deve ridisegnarsi ogni secondo per un numero che non c'e'.
 */
export function useAdesso(attivo) {
  const [adesso, setAdesso] = useState(Date.now());
  useEffect(() => {
    if (!attivo) return undefined;
    setAdesso(Date.now());
    const t = setInterval(() => setAdesso(Date.now()), 1000);
    return () => clearInterval(t);
  }, [attivo]);
  return adesso;
}
